var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#E1E9F0",
    fill: "#F0F4F8",
    x: -0.5,
    y: -0.5,
    width: 33,
    height: 33,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.533 25.174a3.204 3.204 0 01-3.2-3.201v-2.134a1.067 1.067 0 112.134 0v2.134c0 .589.477 1.066 1.066 1.067h14.934c.589-.001 1.066-.478 1.066-1.067v-2.134a1.067 1.067 0 112.134 0v2.134a3.204 3.204 0 01-3.2 3.2H8.533zm8.8-18.007v7.5h2.96a.5.5 0 01.39.812l-4.293 5.366a.5.5 0 01-.78 0l-4.293-5.366a.5.5 0 01.39-.812h2.96v-7.5a.5.5 0 01.5-.5h1.666a.5.5 0 01.5.5z",
    fill: "#9BADBC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default ForwardRef;